import {ApiReleasedEventPermissions} from "../constants/ApiPermissions";
import RulesetBase from "./rulesetBase";

/**
 * Ruleset for released events
 *
 * @class
 * @extends {RulesetBase}
 */
class ReleasedEventRuleset extends RulesetBase {
  defineRules = (userPermissions: string[]): void => {
    const {can} = this.abilityBuilder;

    for (let permission of userPermissions) {
      if (
        permission.toUpperCase() ===
        ApiReleasedEventPermissions.delete.toUpperCase()
      ) {
        can("Delete", "ReleasedEvent");
        break;
      }
    }
  };
}

export default ReleasedEventRuleset;
